import { SectionMediaProps } from '@portfolio/models'
import { Media, MuxPlayer } from '@portfolio/components'
import { styled } from '@portfolio/styles'

const SectionMediaWrapper = styled('div', {
  overflow: 'hidden',
  position: 'relative',
  marginBlockEnd: 30,
  width: '100%',
  borderRadius: 8,
})

export function SectionMedia({ media }: SectionMediaProps) {
  if (!media) {
    return null
  }

  return (
    <SectionMediaWrapper>
      {'mediaPayload' in media ? (
        <Media {...media} layout="responsive" disablePlaceholderBackground />
      ) : (
        <MuxPlayer
          playbackId={media.playbackId}
          poster={media.firstFrame}
          isAutoPlay
        />
      )}
    </SectionMediaWrapper>
  )
}
